import { render, staticRenderFns } from "./ProspectFirstPage.vue?vue&type=template&id=3babbea2&scoped=true"
import script from "./ProspectFirstPage.vue?vue&type=script&lang=js"
export * from "./ProspectFirstPage.vue?vue&type=script&lang=js"
import style0 from "./ProspectFirstPage.vue?vue&type=style&index=0&id=3babbea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babbea2",
  null
  
)

export default component.exports